import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid } from '@material-ui/core'
import IconAndText from 'components/common/IconAndText'
import RecentScans from '../../CopilotSettings/icons/Insights/RecentScans'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'

const ScanInsightsHeader = () => {
  const { t } = useTranslation()

  return (
    <Grid container direction="row" alignItems="center" spacing={1}>
      <Grid item xs={6}>
        <IconAndText
          icon={<RecentScans />}
          text={
            <DazzedParagraph14>
              {t('pages.patients.patientSidebar.items.copilot.copilotInsights.scanInsights.recentScansTitle')}
            </DazzedParagraph14>
          }
        />
      </Grid>
      <Grid item xs={6}>
        <DazzedParagraph14>
          {t('pages.patients.patientSidebar.items.copilot.copilotInsights.scanInsights.oralHygieneTitle')}
        </DazzedParagraph14>
      </Grid>
    </Grid>
  )
}

export default ScanInsightsHeader
